<template>
	<ProgressSpinner v-if="!asset"/>
	<Container class="pt-6" v-if="asset">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>
				{{ asset.name ?? $route.params.asset }}
				<span v-if="asset.is_deleted" class="ml-2 px-2 py-1 text-xs bg-yellow-200 text-yellow-800 rounded align-middle">Deleted</span>
			</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@on-delete="$emit('on-delete')"
				:asset="asset"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";
import Container from "@/Components/Container.vue";


export default {
	name: "AssetAdminView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			asset: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
		methods: {
		async refreshAsset() {
			this.asset = await this.assetsStore.showAsset(this.$route.params.asset, {
			fields: {
				assets: [
					'id',
					'name',
					'company_id',
				]
			},
			include: [
			'devices',
			'devices.deviceType',
			'devices.company',
			],
		});

			if (this.asset?.devices) {
				this.asset.devices = this.asset.devices.filter(device => device?.pivot?.active);
			}
		},
		async onSave() {
			this.$emit('on-save');
		},
	},
	watch: {
		'$route.params.asset': {
			async handler(newValue, oldValue) {
				if(newValue){
					// Reset asset immediately to avoid showing previous asset's name
					this.asset = undefined;
					if(this.$route.params.asset === 'NEW'){
						this.asset = {};
					} else {
						await this.refreshAsset();
					}
				} else {
					this.asset = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useAssetsStore),
		tabs() {
			return [
				{
					label: this.$t('common.properties'),
					current: this.$route.name === 'admin.assets.asset',
					to: {name: 'admin.assets.asset', params: this.$route.params}
				},
				{
					label: this.$t('common.devices'),
								current: this.$route.name === 'admin.assets.asset.devices',
								to: {name: 'admin.assets.asset.devices', params: this.$route.params},
					permission: 'create:asset-devices|update:asset-devices',
					hide: !this.asset.id
				},
				{
					label: this.$t('common.transfer_ownership'),
							current: this.$route.name === 'admin.assets.asset.transfer_ownership',
							to: {name: 'admin.assets.asset.transfer_ownership', params: this.$route.params},
					permission: 'create:asset-transfers|read:asset-transfers',
					hide: !this.asset.id
				},
				{
					label: this.$t('common.history'),
					current: this.$route.name === 'admin.assets.asset.history',
					to: {name: 'admin.assets.asset.history', params: this.$route.params},
				},
			].filter(t => (t.permission === undefined || this.$auth.hasPermission(t.permission)) && !t.hide)
		}
	},
}
</script>
